export type Feature = {
  icon: string;
  title: string;
  intro: string;
  points: string[];
};

export const features: Feature[] = [
  {
    icon: "ri-file-text-line",
    title: "文字提取",
    intro: "一键抽取网页正文与标题，告别逐段复制粘贴。",
    points: ["保留段落结构与排版", "可一键复制纯文本", "过滤广告与导航噪音"],
  },
  {
    icon: "ri-image-2-line",
    title: "图片提取",
    intro: "批量列出页面全部图片素材，按需保存。",
    points: ["自动识别高清原图", "支持批量打包预览", "可复制图片直链"],
  },
  {
    icon: "ri-play-circle-line",
    title: "视频解析",
    intro: "解析页面内嵌视频的真实地址与清晰度信息。",
    points: ["识别页面内嵌播放源", "展示可选清晰度", "提供可复制的链接"],
  },
  {
    icon: "ri-link-m",
    title: "链接提取",
    intro: "汇总页面所有超链接，快速梳理跳转关系。",
    points: ["按类型区分链接", "保留锚点与原文标签", "一键复制清单"],
  },
  {
    icon: "ri-database-2-line",
    title: "数据抓取",
    intro: "结构化抓取表格、列表与字段数据，便于分析。",
    points: ["识别表格与列表结构", "导出为整洁格式", "适合资料归档整理"],
  },
  {
    icon: "ri-code-s-slash-line",
    title: "源码查看",
    intro: "查看网页 HTML 结构与关键元素，定位内容来源。",
    points: ["高亮展示关键节点", "定位图片与脚本", "便于反向溯源"],
  },
];

export type Scene = {
  icon: string;
  title: string;
  desc: string;
  tag: string;
  image: string;
};

export const scenes: Scene[] = [
  {
    icon: "ri-bard-line",
    title: "吃瓜事件回顾",
    desc: "事件发酵后原文常被修改或删除，趁早提取完整文字与截图，避免好瓜烂在评论区。",
    tag: "吃瓜回顾",
    image: "",
  },
  {
    icon: "ri-pencil-ruler-line",
    title: "新媒体素材收集",
    desc: "为短视频、公众号与图文采集画面与文案参考，提取到的素材直接进选题库。",
    tag: "素材收集",
    image: "",
  },
  {
    icon: "ri-folder-lock-line",
    title: "资料永久存档",
    desc: "把重要的帖子、公告与文章保存为本地文本，防止链接失效、内容下架。",
    tag: "资料存档",
    image: "",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "同行内容分析",
    desc: "抓取竞品页面结构、栏目与关键词分布，反推内容策略，为选题提供依据。",
    tag: "内容分析",
    image: "",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端内容搬运",
    desc: "把手机端刷到的长文、长图一键提取成文本，跨设备继续阅读与编辑。",
    tag: "吃瓜回顾",
    image: "",
  },
  {
    icon: "ri-file-copy-2-line",
    title: "网页证据留存",
    desc: "对争议性声明与公告做快照留底，保留出处与时间，便于后续核对。",
    tag: "资料存档",
    image: "",
  },
];

export type Faq = {
  q: string;
  a: string;
};

export const faqs: Faq[] = [
  {
    q: "「吃瓜网页」真的能提取任意网页内容吗？",
    a: "吃瓜网页面向公开可访问的网页提供提取能力。你只需粘贴链接并选择提取类型，系统便会解析页面正文、图片、视频、链接与源码。对于需要登录或加密的页面，仅能提取可见的公开内容，请遵守相关网站的使用条款与版权规定。",
  },
  {
    q: "提取出来的文字会保留原来的排版吗？",
    a: "文字提取默认返回干净、连续的正文文本，方便直接复制使用；在源码查看模式下，你仍然可以看到页面原始的 HTML 结构与标签层级，保留排版信息以便做进一步处理。",
  },
  {
    q: "视频解析是否支持高清与原画？",
    a: "视频解析会读取页面内嵌播放器的真实视频地址，并尽可能展示各清晰度来源。能否拿到最高清晰度取决于页面本身提供的链接是否对外可访问，建议优先提取页面允许的公开清晰度资源。",
  },
  {
    q: "提取的内容可以用来做什么？",
    a: "适合用于个人资料归档、吃瓜事件回顾、新媒体素材整理和同行内容分析等场景。使用时请尊重原作者版权，引用注明出处，避免商用转载未授权内容。",
  },
  {
    q: "为什么有时提取到的图片或链接不完整？",
    a: "部分网页采用动态加载，正文会随滚动逐渐出现。建议先让页面完整渲染后再提取；同时个别防盗链图片或脚本生成的链接可能无法直接访问，这时可切换到源码查看，手动定位真实地址。",
  },
  {
    q: "提取的资料会保存到哪里？",
    a: "提取结果默认展示在页面中，由你手动复制保存到本地。吃瓜网页不代管你的数据，保证隐私与自主可控；如需批量与长期管理，可将整理好的文本或链接清单保存到自己的笔记或网盘。",
  },
];

export const sceneTags = ["全部场景", "吃瓜回顾", "素材收集", "资料存档", "内容分析"];